import React, { Component } from "react";
import { connect } from 'react-redux';
import * as actionCreators from '../../../../modules/actions/index';
import MapPositions from '../../../../components/OrganizationSetup/MapPositions/MapPositions';

class MapPositionsSetup extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    this.props.resetMapPositionsStep();
  }

  handleFileUpload = (columns, data, file) => {
    this.props.onFileDataProcessed(columns, data, file);
  }

  handleMatchColumn = (matchedColumn) => {
    this.props.onMatchColumn(matchedColumn);
  }

  handleSkipMapping = () => {
    // console.log('Skip positions mapping');
  }

  render() {
    return (
      <div className="mb20 mt60">
        <MapPositions 
          onProcessedFileUploadData={this.handleFileUpload}
          onMapGenderMatchColumn={this.handleMatchColumn}
          onSkipPositionMapping={this.handleSkipMapping}
          {...this.props}/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.profile,
    mapPositions : state.mapping.positions
  }
}

const mapDispatchToProps = dispatch => {
	return {
    resetMapPositionsStep: () => dispatch(actionCreators.resetMapPositionsStep()),
    nextStep: () => dispatch(actionCreators.mapPositionsNextStep()),
    goBack : () => dispatch(actionCreators.mapPositionsGoBack()),
    saveAllPositionsMapping : (o,s) => dispatch(actionCreators.saveAllPositionsMapping(o,s)),
    onFileDataProcessed: (c,d,f) => dispatch(actionCreators.mapPositionsUploadFileSuccess(c,d,f)),
    onMatchColumn: data => dispatch(actionCreators.mapPositionsMatchColumnSuccess(data))
	}
}


export default connect(mapStateToProps,mapDispatchToProps)(MapPositionsSetup);